import { render } from "./PaymentCardnumber.vue?vue&type=template&id=084f9060&scoped=true"
import script from "./PaymentCardnumber.vue?vue&type=script&lang=js"
export * from "./PaymentCardnumber.vue?vue&type=script&lang=js"

import "./PaymentCardnumber.vue?vue&type=style&index=0&id=084f9060&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-084f9060"

export default script